// Removed Spin import
import { faSpinner } from '@fortawesome/free-solid-svg-icons'; // Replaced Ant Design icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import MediaQuery from 'react-responsive';
// Added CBSpin import
import { CBSpin } from './CBSpin';
import { ReactComponent as Chevron} from "../../../images/svg/arrow-right-chevron.svg";
const loadIcon = <FontAwesomeIcon icon={faSpinner} className="text-2xl text-neutral-400" spin />;

const CBButton = ({type="primary", children, onClick, icon, long=false,disabled=false,mobileStep=false,loading=false,badge}) => {
    function getButton(){
      if(mobileStep) {
        return <button disabled={disabled} className={`flex items-center text-manrope text-xl w-full pt-4 pb-4 pl-4 pr-4 rounded-lg ${disabled ? 'text  bg-neutral_2' :'text-white bg-darkblue_highlight'}`} onClick={e => {
     // e.stopPropagation(); // Removed stopPropagation
          if(onClick) {
            onClick(e)
        }}}>{badge != null && <div className="rounded-full mr-4 text-neutral_4 bg-white text-sm border-0 h-8 w-8 flex items-center justify-center">{badge}</div>}<div>{children}</div> {long ? <><div className="flex-grow"></div><div>{icon}</div></> : icon}</button>
      } else {
    return <button disabled={disabled} className={`btn-${type}${disabled ? '-disabled' : ''}${(long ? ' w-full' : '')}`} onClick={e => {
   // e.stopPropagation(); // Removed stopPropagation
        if(onClick) {
          onClick(e)
      }}}> {children && <div>{children}</div>}{long ? <><div className="flex-grow"></div><div>{icon}</div></> : icon}</button>
    }
    }
  
  
   // Replaced Spin with CBSpin
   // Note: CBSpin overlays by default when children are present.
   // If the intention was to replace the button content with the spinner,
   // the logic needs adjustment. Assuming overlay is acceptable for now.
   return (
     <CBSpin spinning={loading} indicator={loadIcon}>
       {getButton()}
     </CBSpin>
   );
  }
  
  const SubmitButton =({type="primary",children,onClick,icon,long=false,disabled=false, loading=false, badge}) => {
    return (<>
    <MediaQuery maxDeviceWidth={1224}>
    
      <CBButton disabled={disabled} type={type} onClick={onClick} icon={<Chevron></Chevron>} loading={loading} long={true} badge={badge} mobileStep={true}>{children}</CBButton>
    </MediaQuery>
    <MediaQuery minDeviceWidth={1224}>
    <div className="flex mt-8 mb-8 "> <div className="flex-grow"></div><CBButton loading={loading} disabled={disabled} type={type} onClick={onClick} icon={<Chevron></Chevron>} long={long}>{children}</CBButton></div>
    </MediaQuery>
    </>)
   
  }

  export { CBButton, SubmitButton };
